import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { getSerializedListByStoreCompany } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import { showInfoToast } from "../../components/ToastMesg";
import DataGrid from "../../components/DataGrid";

const Serialized = () => {
  const navigate = useNavigate();
  const { storeG, companyG, userPermID } = useStateContext();
  const [AllSerialized, setAllSerialized] = useState("");
  const [Serialized_id, setSerialized_id] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);

  const customersGrid = [
    {
      field: "sn",
      headerText: "SN",
      minWidth: "80",
      width: "100",
      maxWidth: "150",
      textAlign: "left",
    },
    {
      field: "mfg_sn",
      headerText: "Mfg SN",
      minWidth: "115",
      width: "130",
      maxWidth: "280",
      textAlign: "left",
    },
    {
      field: "part_number",
      headerText: "Part No",
      minWidth: "125",
      width: "130",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "description",
      headerText: "Part Description",
      minWidth: "180",
      width: "220",
      maxWidth: "880",
      textAlign: "left",
    },
    {
      field: "so_id",
      headerText: "SO #",
      minWidth: "105",
      width: "110",
      maxWidth: "120",
      textAlign: "center",
    },
    {
      field: "so_customer",
      headerText: "SO Customer",
      minWidth: "155",
      width: "165",
      maxWidth: "240",
      textAlign: "left",
    },
    {
      field: "parent_sn",
      headerText: "Parent SN",
      minWidth: "135",
      width: "140",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "po_id",
      headerText: "PO #",
      minWidth: "105",
      width: "110",
      maxWidth: "120",
      textAlign: "center",
    },
    {
      field: "recveive_date",
      headerText: "Recv Date",
      minWidth: "135",
      width: "140",
      maxWidth: "150",
      textAlign: "left",
    },
    {
      field: "po_vendor",
      headerText: "PO Vendor",
      minWidth: "140",
      width: "150",
      maxWidth: "240",
      textAlign: "left",
    },
    {
      field: "physical_location",
      headerText: "Physical Location",
      minWidth: "190",
      width: "195",
      maxWidth: "220",
      textAlign: "left",
    },
    {
      field: "in_kit_status",
      headerText: "In-Kit Status",
      minWidth: "150",
      width: "160",
      maxWidth: "180",
      textAlign: "left",
    },
  ];

  const handleEditSerializedClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Serialized_id !== "")
      navigate(`/Serialized/EditSerialized/${Serialized_id}`);
    else showInfoToast("Info!", "Please select Part to edit!");
  };

  const handleAssignSOClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (companyG.company_id) navigate(`/Serialized/AssignSerialized`);
    else showInfoToast("Info!", "Please select Company to proceed!");
  };

  const handleAssignClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Serialized_id !== "") {
      if (companyG.company_id)
        navigate(`/Serialized/AssignSerialized/${Serialized_id}`);
      else showInfoToast("Info!", "Please select Company to proceed!");
    } else showInfoToast("Info!", "Please select Part to assign!");
  };

  const handleViewSerClick = () => {
    TimeoutUtility.resetTimeout();
    if (Serialized_id !== "")
      navigate(`/Serialized/ViewSerialized/${Serialized_id}`);
    else showInfoToast("Info!", "Please select Part to view!");
  };

  const handleRowSelected = (args) => setSerialized_id(args.data.sn_id);

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      let cmp_id = 0;
      if (companyG.company_id) cmp_id = companyG.company_id;
      const resp = await getSerializedListByStoreCompany(
        storeG.store_id,
        cmp_id,
      );
      setAllSerialized(resp.data || []);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        setloading(true);
        let cmp_id = 0;
        if (companyG.company_id) cmp_id = companyG.company_id;
        trackPromise(
          getSerializedListByStoreCompany(storeG.store_id, cmp_id)
            .then((productsResponse) => setAllSerialized(productsResponse.data))
            .catch((error) => console.error("Error fetching data:", error))
            .finally(() => setloading(false)),
        );
      }
    };
    fetchData();
  }, [storeG, companyG]);

  return (
    <div>
      <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
        <Row>
          <Col xl={3} md={5}>
            <Header category="Stock" title="SERIALIZED PARTS" />
          </Col>
          <Col xl={6} md={5} className="text-center">
            <Header title={companyG.name} />
          </Col>
        </Row>
        <Container fluid className="g-0 p-0 justify-end">
          <Row xs={2} className="button-row justify-content-end font-normal">
            {userPermID.includes(24) && (
              <>
                <Col md="auto p-0">
                  <Button text="Update" onClick={handleEditSerializedClick} />
                </Col>
                <Col md="auto p-0">
                  <Button text="Assign SO#" onClick={handleAssignSOClick} />
                </Col>
                <Col md="auto p-0">
                  <Button text="Assign Child SNs" onClick={handleAssignClick} />
                </Col>
              </>
            )}
          </Row>
        </Container>
        <DataGrid
          loading={loading || promiseInProgress}
          data={AllSerialized}
          cols={customersGrid}
          handleRowSelected={handleRowSelected}
          handleDoubleClick={userPermID.includes(23) && handleViewSerClick}
          persistant={true}
          handleRefresh={handleRefresh}
        />
      </div>
    </div>
  );
};

export default Serialized;
